import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import '@/plugins/veevalidate'
import './plugins/apexcharts'
import '@/plugins/common'
import App from './App.vue'
import router from './router'
import '@/plugins/aws'
import { VueMaskDirective } from 'v-mask'
//import canvas2image from './plugins/canvas2image'
import '@/plugins/canvas2image'
import browserDetect from "vue-browser-detect-plugin"

import i18n from '@/plugins/i18n'
import CountryFlag from 'vue-country-flag'
import { store } from '@/store'

import moment from 'moment'
Vue.prototype.moment = moment

Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false

Vue.use(browserDetect)

Vue.directive('mask', VueMaskDirective);

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    store.dispatch('setLocale', store.getters.locale)
    if (store.getters.isTokenSet) {
      store.dispatch('autoLogin')
    }
  }
}).$mount('#app')
